var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.readonly)?_c('a-input',{attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):[_vm._v(" "+_vm._s(_vm.val)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }